const Data = {
  menuItems: [
    {
      name: "Inicio",
      path: "inicio",
      offset: "-120",
    },
    {
      name: "Ventajas",
      path: "service",
      offset: "-120",
    },
    {
      name: "Contáctanos",
      path: "about",
      offset: "-100",
    },

    {
      name: "Scrapys",
      path: "scrapys",
      offset: "-100",
    },
    {
      name: "Preguntas F.",
      path: "faq",
      offset: "-60",
    },
    {
      name: "Tecnologías",
      path: "stack",
    },
 
  ],
}
export default Data
